module.exports = __webpack_public_path__ + "static/media/trimex_diezlustros.e75ba88b.png";